import { render, staticRenderFns } from "./MediaContent.vue?vue&type=template&id=052ead76&"
import script from "./MediaContent.vue?vue&type=script&lang=js&"
export * from "./MediaContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports